export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_HAND_PAGE_LIST: function GET_HAND_PAGE_LIST(data) {
      return request({
        url: '/admin/hand/getPageList',
        method: 'post',
        data: data
      });
    }
  };
});